// extracted by mini-css-extract-plugin
export default {"ModalContainer":"RecoverPasswordModal_ModalContainer__TJbCm"};